import { CatalogServiceBase } from './catalog-service';
export class PublicCatalogService extends CatalogServiceBase {
}
//# sourceMappingURL=public-catalog-service.js.map